import {CommonAlertService} from './../../services/common-alert.service';
import {ConfirmationModalComponent} from './../confirmation-modal/confirmation-modal.component';
import {MasterService} from './../../home/services/master.service';
import {ProductViewModalComponent} from './../product-view-modal/product-view-modal.component';
import {filter} from 'rxjs/operators';
import {StockService} from '../../home/services/stocks.service';
import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewChildren,
  QueryList
} from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog
} from '@angular/material/dialog';
import {MatDatepickerModule} from '@angular/material/datepicker';

@Component({
  selector: 'app-invoice-modal',
  templateUrl: './invoice-modal.component.html',
  styleUrls: ['./invoice-modal.component.scss']
})
export class InvoiceModalComponent implements AfterViewInit, OnInit {
  @ViewChild('addAtribute', {static: false})
  addAtribute: ElementRef;
  // public rows: any = [{ 'code': '', 'name': "", 'expirydate': '', 'batch': '', 'quantity': ''
  // ,'rate': '', 'discount': '', 'amount': ''}];
  public newRow: any;
  public invoiceData: any;
  public selectedOrder: any;
  public model = {
    selectedOrder: ''
  };
  public locationData: any;
  public Countries: any;
  public totals = {
    gT: 0,
    d: 0,
    nT: 0
  };

  public headObj = {
    datePick: '',
    coutry: '',
    warehouse: '',
    batchNo: ''
  };

  public editHeadObj = {
    dataPick: new Date().toLocaleDateString(),
    country: '',
    warehouse: '',
    batch_no: ''
  };

  public indexTotals = {
    total: 0
  };

  public productResult: Array<any> = [
    {
      code: '',
      name: '',
      expirydate: '',
      batch_no: '',
      quantity: '',
      rate: '',
      discount: '',
      amount: '',
      showDis: '',
      items: {}
    }
  ];

  public editTotal = {
    gt: 0,
    nt: 0,
    d: 0
  };
  public changeAmount: number;
  public today: Date;
  @ViewChild('myInput', {static: true})
  myInput: ElementRef;
  public mymodel: any;
  public selectedQn: any;
  public value1: any;
  public value2: any;
  // tslint:disable-next-line:variable-name
  public total_amount: any;
  // tslint:disable-next-line:variable-name
  public total_dis: any;
  // tslint:disable-next-line:variable-name
  public invc_id: any;
  // tslint:disable-next-line:variable-name
  public inc_enc: any;
  // tslint:disable-next-line:variable-name
  public invc_editD: any;
  // tslint:disable-next-line:variable-name
  public invc_editD_Pro: any;
  // tslint:disable-next-line:variable-name
  public invoice_edit_obj: any;
  public editFormData: any = {};
  public purchaseOrder: Array<any> = [
    {
      id: '',
      status: ''
    }
  ];
  newBatchNo: any;
  batch: any;
  productArrFlag = true;
  expiry_date:any;
  public showDiscount = false;
  public editObj: any;
  public items: any = {};
  public editPermission = false;
  public filter: any;
  public barcodeData: any;
  constructor(
    public dialogRef: MatDialogRef<InvoiceModalComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public stockService: StockService,
    public dialog: MatDialog,
    public masterService: MasterService,
    public alrtService: CommonAlertService
  ) {

    if (data) {
      this.invc_id = data.id,
        this.inc_enc = data.enc_Id;
    }
  }

  ngAfterViewInit() {
    // console.log(this.newRow);
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['invoice.edit'] == 1) {
        this.editPermission = true;
      }
    }
    this.getCurrentDate();
    // tslint:disable-next-line:variable-name
    const invc_url = '/invoices/get_data';
    const id = 0;

    this.masterService.getData('/purchase_orders/available').subscribe(res => {
      // @ts-ignore
      this.purchaseOrder = res.data;
    });

    if (this.invc_id) {
      this.masterService.getRecordById(this.invc_id, this.inc_enc, invc_url)
        .subscribe(res => { 
          // @ts-ignore
          this.invc_editD = res.data;
          console.log(this.invc_editD);
          // @ts-ignore
          this.editHeadObj.dataPick = res.data.invoice.date;
          // tslint:disable-next-line:variable-name
          // @ts-ignore
          this.editHeadObj.country = res.data.invoice.country_id;
          // @ts-ignore
          this.invc_editD_Pro = res.data.invoice_products;

          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < this.invc_editD_Pro.length; i++) {
            Object.assign(this.invc_editD_Pro[i], {showDis: ''});
            this.invc_editD_Pro[i].name = this.invc_editD_Pro[i].product_name;
            // this.batchEdit = this.invc_editD_Pro[i].batch_no;
            // tslint:disable-next-line:max-line-length
            this.invc_editD_Pro[i].showDis = (this.invc_editD_Pro[i].quantity * this.invc_editD_Pro[i].rate * this.invc_editD_Pro[i].discount) / 100;
            this.cal();
          }

          this.invc_editD_Pro.map(r => r.product_name);
          // @ts-ignore
          this.invoice_edit_obj = res.data.invoice;
          this.editTotal.gt = this.invoice_edit_obj.grand_total;
          this.editTotal.nt = this.invoice_edit_obj.net_total;
        });

    }

  }

  getCurrentDate() {
    const today = new Date();
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    return this.headObj.datePick = dd + '/' + mm + '/' + yyyy;
  }

  close() {
    this.dialogRef.close();
  }

  deleteRow(index) {
    if (!this.invc_id) {
      this.items.splice(index, 1);
    } else {
      this.invc_editD_Pro.splice(index, 1);
    }
    this.cal();
  }

  selectedOrderFn(event: Event) {
    const url = '/purchase_orders/get_invoice_data';
    this.masterService.getRecordById(this.selectedOrder, this.selectedOrder, url)
      .subscribe(res => {
        // @ts-ignore
        this.productResult.items = res.data.purchase_order_item;
        // @ts-ignore
        this.items = res.data.purchase_order_item;
        // @ts-ignore
        this.productResult = res.data.purchase_order;
        // @ts-ignore
        this.totals.gT = this.productResult.grand_total;
        // @ts-ignore
        this.totals.d = this.productResult.total_discount;
        // @ts-ignore
        this.totals.nT = this.productResult.net_total;
      });

  }

  blur(eve, type, i) {
    if (!this.invc_id) {
      this.items[i][type] = parseFloat(eve.target.value);
      // tslint:disable-next-line:max-line-length
      this.items[i].rate = (this.items[i].amount * this.items[i].quantity) - ((this.items[i].discount / 100) * (this.items[i].amount * this.items[i].quantity));
    } else {
      this.invc_editD_Pro[i][type] = parseFloat(eve.target.value);
      // tslint:disable-next-line:max-line-length
      this.invc_editD_Pro[i].showDis = (this.invc_editD_Pro[i].quantity * this.invc_editD_Pro[i].rate * this.invc_editD_Pro[i].discount) / 100;
    }
    this.cal();
    // this.calDiscount();
  }
  quantityChange(eve, type, i) {
    this.items[i].quantity = parseFloat(eve.target.value);
    // tslint:disable-next-line:max-line-length
    this.items[i].rate = (this.items[i].amount * this.items[i].quantity) - ((this.items[i].discount / 100) * (this.items[i].amount * this.items[i].quantity));
    this.cal();
    // this.calDiscount();
  }

  prizeChange(eve, type, i) {
    this.items[i].amount = (parseFloat(eve.target.value))?parseFloat(eve.target.value):0;
    if (this.items[i].quantity > this.items[i].pending_quantity) {
      this.items[i].quantity = this.items[i].pending_quantity;
    }
    // tslint:disable-next-line:max-line-length
    this.items[i].rate = (this.items[i].amount * this.items[i].quantity) - ((this.items[i].discount / 100) * (this.items[i].amount * this.items[i].quantity));
    this.cal();
    // this.calDiscount();
    console.log(this.items[i].rate+'..'+this.items[i].quantity+'..'+this.items[i].amount);
  }


  discountChange(eve, type, i) {
    this.items[i].discount = (parseFloat(eve.target.value))?parseFloat(eve.target.value):0;
    if (this.items[i].quantity > this.items[i].pending_quantity) {
      this.items[i].quantity = this.items[i].pending_quantity;
    }
    // tslint:disable-next-line:max-line-length
    this.items[i].rate = (this.items[i].amount * this.items[i].quantity) - ((this.items[i].discount / 100) * (this.items[i].amount * this.items[i].quantity));
    this.cal();
    // this.calDiscount();
  }

  blurDis(eve) {
    if (!this.invc_id) {
      this.totals.d = parseFloat(eve.target.value);
      this.cal();
    } else {
      this.editTotal.d = parseFloat(eve.target.value);
      this.cal();
    }

  }

  cal() {
    this.showDiscount = true;
    // tslint:disable-next-line:one-variable-per-declaration prefer-const
    let sum = 0, disc = 0, nt = 0;
    if (!this.invc_id) {
      //  let sum = 0, disc = 0, nt = 0;
      this.items.map(item => {
        if (!isNaN(item.amount) && !isNaN(item.quantity) && !isNaN(item.discount)) {
          sum += item.amount * item.quantity;
          disc += (item.discount / 100) * (item.amount * item.quantity);
        }
      });
      this.totals.gT = sum;
      this.totals.nT = sum - disc;
      this.totals.d = disc;
    } else {
      this.invc_editD_Pro.map(item => {
        if (!isNaN(item.amount) && !isNaN(item.quantity) && !isNaN(item.discount)) {
          sum += item.amount * item.quantity;
          disc += item.showDis;
        }
      });
      this.editTotal.gt = sum;
      this.editTotal.nt = sum - disc;
      this.editTotal.d = disc;

    }

  }

  calculate() {
    // tslint:disable-next-line:variable-name
    const quantity_cal: any = (document.getElementById(
      'value1'
    ) as HTMLInputElement).value;
    // tslint:disable-next-line:variable-name
    const rate_cal: any = (document.getElementById('value2') as HTMLInputElement)
      .value;
    this.changeAmount = quantity_cal * rate_cal;
  }

  submitForm(val) {
    
    if (!this.invc_id) {
      const url = '/invoices/store';

      // tslint:disable-next-line:variable-name
      const form_data = {};
      Object.assign(form_data, {
        token: localStorage.getItem('token'),
        grand_total: this.totals.gT,
        total_discount: this.totals.d,
        purchase_order_id: this.selectedOrder,
        net_total: this.totals.nT,
        date: this.headObj.datePick,
        invoice_products: this.items,
        deleted_invoice_ids: {}
      });
     
      this.masterService.addEditRecord(form_data, url).subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.alrtService.showSuccessMsg({message: 'Record Added Succefully'});
        }
      });

      this.close();

    }

  }

  confirmationModal(i, row) {
    // tslint:disable-next-line:variable-name
    const product_id = row.id;
    // tslint:disable-next-line:no-unused-expression
    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      minWidth: '50vw',
      minHeight: '20vh',
      disableClose: true,
      data: product_id
    }).afterClosed().subscribe(() => this.ngOnInit());

  }
}
